import { DAY_FORMAT } from '@lib/inspections/filters';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

/**
 * Today, as a day in the reader's time zone (`YYYY-MM-DD`), turning over at midnight. A day
 * read once kept a page left open overnight asking for yesterday's "Today", and "Last Week"
 * a day behind. A timer set a second past each midnight moves it and sets the next one. A
 * browser's timers do not count time asleep on Linux and macOS, so a computer asleep at
 * midnight wakes with the timer still hours away: the day is also read again whenever the
 * page is shown or gets the focus.
 */
export const useToday = (): string => {
  const [today, setToday] = useState(() => dayjs().format(DAY_FORMAT));

  useEffect(() => {
    let timer: number | undefined;

    const arm = () => {
      const untilMidnight = dayjs().add(1, 'day').startOf('day').add(1, 'second').diff(dayjs());

      timer = window.setTimeout(() => {
        setToday(dayjs().format(DAY_FORMAT));
        arm();
      }, untilMidnight);
    };

    arm();

    const refresh = () => setToday(dayjs().format(DAY_FORMAT));

    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('focus', refresh);

    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, []);

  return today;
};
